import { registerComponent, handleize, fetchCollection } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "predictive-search-result-brand",
  class PredictiveSearchResultBrand extends WYATTElement {
    constructor() {
      super();

      this.data = JSON.parse(this.dataset.result);
      this.link = this.querySelector("a");

      this.setText();
      this.setHref();
    }

    get handle() {
      return handleize(this.data.value);
    }

    get collectionUrl() {
      return `${WYATT.routes.root}collections/${this.handle}`;
    }

    get searchUrl() {
      return `${WYATT.routes.root}search?q=${encodeURIComponent(this.data.value)}`;
    }

    setText() {
      this.link.innerHTML = this.data.label;
    }

    // Search results work for every vendor, so the link starts there and
    // moves to the collection once it's confirmed. Same rule as the product
    // card vendor link (snippets/vendor-link.liquid): the collection must
    // exist and have products.
    async setHref() {
      this.link.href = this.searchUrl;

      const collection = await fetchCollection(this.handle);

      if (collection?.products_count > 0) {
        this.link.href = this.collectionUrl;
      }
    }
  },
);
